import React, { useState, useEffect } from "react";
import { apiFetch } from "../lib/api";
import { GraduationCap } from "lucide-react";

export default function TrainingMatrix() {
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);

  const loadData = async () => {
    try {
      setLoading(true);
      const res = await apiFetch("/training-matrix");
      if (res?.ok) setItems(res.items || []);
    } catch {
      // Fallback
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => { loadData(); }, []);

  return (
    <div className="space-y-4" id="training-matrix-page" data-testid="training-matrix-page">
      <div className="flex items-center justify-between">
        <div>
          <h1 className="text-xl font-bold text-[#082B4D] flex items-center gap-2">
            <GraduationCap className="w-5 h-5 text-[#18B84F]" />
            Training Competency Matrix & Iqama Masking Protection
          </h1>
          <p className="text-xs text-slate-500">Role-based mandatory training, assessment results, authorization status & privacy masking</p>
        </div>
      </div>

      <div className="bg-white rounded-lg border border-slate-200 shadow-sm overflow-hidden text-xs">
        <table className="w-full text-left border-collapse">
          <thead className="bg-slate-50 border-b border-slate-200 text-slate-600 font-semibold uppercase text-[10px]">
            <tr>
              <th className="p-3">Record ID</th>
              <th className="p-3">Course Name</th>
              <th className="p-3">Provider</th>
              <th className="p-3">Training Date</th>
              <th className="p-3">Expiry Date</th>
              <th className="p-3">Result</th>
              <th className="p-3">Authorization</th>
              <th className="p-3">Masked ID</th>
            </tr>
          </thead>
          <tbody className="divide-y divide-slate-100 font-mono">
            {loading ? (
              <tr><td colSpan="8" className="p-4 text-center text-slate-400">Loading training competency matrix...</td></tr>
            ) : items.length === 0 ? (
              <tr><td colSpan="8" className="p-4 text-center text-slate-400">No competency records found.</td></tr>
            ) : (
              items.map((r) => (
                <tr key={r.id} className="hover:bg-slate-50">
                  <td className="p-3 font-bold text-blue-600">{r.human_readable_id}</td>
                  <td className="p-3 font-sans font-medium text-slate-800">{r.course_name}</td>
                  <td className="p-3 font-sans text-slate-600">{r.trainer_provider_name}</td>
                  <td className="p-3 text-slate-500">{r.training_date}</td>
                  <td className="p-3 text-slate-500">{r.expiry_date}</td>
                  <td className="p-3 font-bold uppercase text-[9.5px]">{r.assessment_result}</td>
                  <td className="p-3"><span className={`px-2 py-0.5 rounded text-[9px] font-bold uppercase ${r.authorization_status === 'authorized' ? 'bg-emerald-100 text-emerald-800' : 'bg-rose-100 text-rose-800'}`}>{r.authorization_status}</span></td>
                  <td className="p-3 text-slate-400">{r.masked_iqama || "****"}</td>
                </tr>
              ))
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
}
